/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-eval */
/* eslint-disable no-alert */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable react/no-danger */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
import React, { useRef, useState, useEffect } from "react";
import {useTranslation} from "react-i18next";
import DOMPurify from "dompurify";
import axios from "axios";
import fetchConfig from "../../Constants/fetch";
import "./AssistantChat.css";

// @TODO: if FlagVar player_chose_to_deduct_from_value is true it needs to be set to false in order to revert it back
const AssistantChat = React.memo(({ assistantJson, gameId, userId, FlagVars, setPressedOkGotIt, assistantSound, SoundPlay }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [, reRender] = useState({});
  const assistantJsonRef = useRef(assistantJson);
  const messagesListRef = useRef([]);
  const flips_tasks_in_same_time_count = useRef(0);
  const [scrollToMessage, setScrollToMessage] = useState(0);
  const [componentDidMountFlag, setComponentDidMountFlag] = useState(false);
  const [chatGameId, setChatGameId] = useState();
  const [triggersQueue, setTriggersQueue] = useState([]);
  const [currentTrigger, setCurrentTrigger] = useState(null);
  const offeredToGoBackRef = useRef(0);
  const offeredToGoBackToStartRef = useRef(0);
  const { t } = useTranslation();

  const triggerCounter = useRef(0);
  const orTaskCount = useRef(FlagVars.orTasks);
  const gameRestartCounter = useRef(FlagVars.isGameGotRestarted);
  const movedTaskBeforePredecessorCount = useRef(FlagVars.movedTaskBeforePredecessorCount);
  const lastBoardPosition = useRef(FlagVars.lastBoardPosition);
  const insertTriggerToLog = async (trigger) => {
    await axios.get(`${fetchConfig.prefix}/game/insertTriggerToLog`, { params: { gameId, userId, trigger, }, });
  };

  // flags:
  const at_least_one_task_flipped = FlagVars.orTasks > 0;
  const on_risk = FlagVars.playerPositionType == "Risk" ? true : false; // should be - on risk
  const on_constraint = FlagVars.playerPositionType == "Constraint" ? true : false; // should be - on risk
  const first_time_opening_project_grid = FlagVars.firstProjectPopup;
  const pressed_ok_got_it = FlagVars.pressedOkGotIt;
  const modified_project = FlagVars.changedProjectOrder;
  const on_planned_task = FlagVars.onPlannedTask;
  const on_start_tile = FlagVars.onStartTile;

  // Problematic term, When the game is restarted the orTask is chnged. and its triggers that trigger. We should pay attention to triggers that can effect the restart game function.
  const task_flip_changed = FlagVars.orTasks != orTaskCount.current && chatGameId == gameId

  const move_task_before_pred = FlagVars.movedTaskBeforePredecessorCount
  const pressed_start_playing = FlagVars.pressedStartPlaying;
  const going_back_on_board = (FlagVars.offeredToGoBack > offeredToGoBackRef.current) && chatGameId == gameId;
  // const going_back_on_board = (FlagVars.playerPosition < lastBoardPosition.current) && chatGameId == gameId;

  const first_welcome_modal = FlagVars.startGameShowModal;
  const pause_for_planning_popup = FlagVars.pauseForPlanningPopUpActive;
  const execute_task_with_open_predecessor = FlagVars.executeTaskWithOpenPredecessor;
  const not_enough_resources_for_task = FlagVars.executeTaskWithNotEnoughResources;
  const unplanned_task_popup = FlagVars.onUnPlannedTask;
  const draw_trap_card =
    FlagVars.isChoosingFromDelayedCard
      ? new Set([14, 15, 16]).has(FlagVars.selectedUnPlannedTaskCarousel)
      : new Set([14, 15, 16]).has(FlagVars.card?.id);
  const can_execute_task =
    FlagVars.card?.id && (
      (FlagVars.card.costResourcesNormal * -1 <= FlagVars.player.resources.regular) &&
      (FlagVars.card.costResourcesSenior * -1 <= FlagVars.player.resources.executive) &&
      (FlagVars.card.costResourcesExpensive * -1 <= FlagVars.player.resources.expensive) &&
      (FlagVars.card.costMoney * -1 <= FlagVars.player.budget)
    );
  // const selected_to_go_back_at_delay = FlagVars.offeredToGoToStart;
  const selected_to_go_back_at_delay = FlagVars.offeredToGoToStart > offeredToGoBackToStartRef.current;
  const after_first_gate_location = FlagVars.playerAfterFirstGate;
  const first_time_gate_modal = FlagVars.firstTimeVisitingGate
  const gate_will_cancel_project = FlagVars.gateTestResult === 'Project is cancelled!';
  const project_finished = FlagVars.playerFinishedGame;
  const on_milestone = FlagVars.BoardCurrentPositionType == "mile-stone"
  const open_general_pm_tasks = FlagVars.openGeneralPmTasks && FlagVars.inGrid
  const executed_remaining_tasks_at_gate = FlagVars.hasExecuteRemainingTasksAtGateRef.current
  let flips_3_tasks_in_same_time = flips_tasks_in_same_time_count.current == 3

  // string literals variables
  const testName = "POC";

  function resetTriggers(condition) {  // to be improved later
    if (condition.includes("pressed_ok_got_it")) {
      setPressedOkGotIt(false);
    }
  }

  useEffect(() => {
    assistantJsonRef.current = assistantJsonRef.current.map(triggerRow => {
      if (triggerRow.response.settings.reset_counter !== false) {
        return { ...triggerRow, response: { ...triggerRow.response, settings: { ...triggerRow.response.settings, showCount: 0 } } }
      }
      return triggerRow;
    });

    if (componentDidMountFlag) { // we don't want to restart the array
      // in the first time when component did mount, only when component did update (on restarting game at gate)
      orTaskCount.current = FlagVars.orTasks
      messagesListRef.current = [];
    } else {
      setComponentDidMountFlag(true);
    }
  }, [FlagVars.isGameGotRestarted]);

  // if gameId change => setChatGameId(gameId) , why its inside useEffect?
  useEffect(() => {
    setChatGameId(gameId);
    assistantJsonRef.current = assistantJson;
    messagesListRef.current = [];
    setTriggersQueue([]);
    setCurrentTrigger(null);
    triggerCounter.current = 0;
  }, [gameId, assistantJson])

  // after render :
  // 1.reset flag
  // 2. handleAssistantJson();
  // 3.if new msg open setIsOpen(true);
  // 4.flags reset
  useEffect(() => {
    if (!FlagVars.inGrid) flips_tasks_in_same_time_count.current = 0
    else if (FlagVars.orTasks != orTaskCount.current) flips_tasks_in_same_time_count.current++
    flips_3_tasks_in_same_time = flips_tasks_in_same_time_count.current == 3
    const currentMessagesListRef = messagesListRef.current;
    handleAssistantJson();
    if (currentMessagesListRef != messagesListRef.current) {
      if (!isOpen) setIsOpen(true);
    }
    // flag reset:
    movedTaskBeforePredecessorCount.current = FlagVars.movedTaskBeforePredecessorCount;  // reset the triggers after the changes were registered
    lastBoardPosition.current = FlagVars.playerPosition;
    FlagVars.hasExecuteRemainingTasksAtGateRef.current = false;
    orTaskCount.current = FlagVars.orTasks
    offeredToGoBackRef.current = FlagVars.offeredToGoBack;
    offeredToGoBackToStartRef.current = FlagVars.offeredToGoToStart;
  }, [FlagVars])

  useEffect(() => {
    if (triggersQueue.length > 0 && !currentTrigger) { // dqueue in case there is a trigger and current trigger is finished
      setCurrentTrigger(triggersQueue[0]);
      setTriggersQueue(triggersQueue.slice(1)); // Remove the processed trigger from the queue
    }
  }, [triggersQueue, currentTrigger])

  // if there is a trigger now, call the response function
  useEffect(() => {
    if (currentTrigger) { // if there is a trigger now, call the response function
      doResponse(currentTrigger)
    }
  }, [currentTrigger]);

  gameRestartCounter.current = FlagVars.isGameGotRestarted;

  const scrollToLastMessage = () => {
    const messages = document.querySelectorAll('.assistant__messages-pc');
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];
      setTimeout(() => {
        lastMessage.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    }

  }

  useEffect(() => scrollToLastMessage(), [scrollToMessage])

  function sanitizeHTML(text) {
        const textWithLineBreaks = text.replace(/\\n/g, '<br/>');
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(textWithLineBreaks, 'text/html');
    const sanitizedHTML = doc.body.innerHTML;
    
    if (sanitizedHTML.includes("https://beingaprojectmanager.com/")) {
      return sanitizedHTML;
    }
      const purifiedHTML = DOMPurify.sanitize(sanitizedHTML);
      return purifiedHTML;
  }
  
  

  function handleAssistantJson() {
    if (assistantJsonRef.current) {
      assistantJsonRef.current = assistantJsonRef.current.map(triggerRow => {
        const resSettings = triggerRow?.response?.settings

        if (resSettings.isShowing !== 1 && eval(triggerRow.action_trigger) == true && // not showing now
          (
            (!resSettings.max_times_to_show || !resSettings.showCount) // no data on max time to show
            || (resSettings.max_times_to_show > resSettings.showCount) // can show another time
          )
        ) {
          insertTriggerToLog(triggerRow)
          resetTriggers(triggerRow.action_trigger)
          // add to queue
          setTriggersQueue((prev) => [...prev, triggerRow]) // add trigger to the queue
          return { ...triggerRow, response: { ...triggerRow.response, settings: { ...triggerRow.response.settings, isShowing: 1, showCount: resSettings?.showCount ? resSettings.showCount + 1 : 1 } } }
        }
        if (resSettings.isShowing == 1 && eval(triggerRow.action_trigger) == false) { // need to stop show him or just add count so u dont re render
          return { ...triggerRow, response: { ...triggerRow.response, settings: { ...triggerRow.response.settings, isShowing: 0 } } }
        }
        return triggerRow;
      });
    }
  }

  function doResponse(triggerRow) {
    messagesListRef.current.forEach(item => {
      item.settings.isOld = true;
    }); // we want the bubbles to turn gray not only if 30 seconds passed,
    // but also if there is a new massage.
    const newTriggerRow = triggerRow;
    const responsesLength = Object.values(newTriggerRow.response).filter((response) => {
      if (!response.settings) return false; // its means we are in settings and not message
      const { settings } = response
      if (!settings.showCount) return true
      if (settings?.max_time_to_show &&
        settings?.showCount &&
        settings.max_time_to_show > settings.showCount) return true
      if (!settings?.max_time_to_show) return true
      return false;
    }).length
    const resSettings = newTriggerRow?.response?.settings
    resSettings.showCount = resSettings?.showCount ? resSettings.showCount + 1 : 1; // log how many times the modal has been showed
    if (resSettings.reset_messages_list == 1) messagesListRef.current = []; // this will reset the list before the trigger
    Object.entries(newTriggerRow.response).forEach(([key, value], index) => {
      const bubbleSettings = newTriggerRow.response[key].settings;
      if (key == "settings") return;
      if (typeof bubbleSettings.max_time_to_show == 'undefined' || bubbleSettings.max_time_to_show >= resSettings.showCount) { // each bubble has also max time we want to show.
        newTriggerRow.response[key] = doSubResponse(value, key, responsesLength, newTriggerRow.id)
      }
    });
    return newTriggerRow;
  }

  function doSubResponse(subResponse, key, responsesLength, assistantId) {
    const newSubResponse = { ...JSON.parse(JSON.stringify(subResponse)), perent: subResponse, assistantId }
    newSubResponse.index = key;
    if (!subResponse.settings) subResponse.settings = {};
    subResponse.settings.showCount = subResponse.settings?.showCount ? subResponse.settings.showCount + 1 : 1; // log how many times the modal has been showed
    setTimeout(() => {
      messagesListRef.current = [...messagesListRef.current, newSubResponse];
      triggerCounter.current += 1; // counting how much 'subResponse' we showed so far
      if (!isOpen) setIsOpen(true);
      SoundPlay(assistantSound);
      setScrollToMessage(prev => prev + 1)
      if (triggerCounter.current == responsesLength) { // ETAMAR FIX HERE MAX TIME TO SHOW
        triggerCounter.current = 0;
        setCurrentTrigger(null); // if the condition is true it means that we arrived to the last 'subResponse' and we need to reset variables.
      }
    }, 1000 * key);

    newSubResponse.settings.isOld = false; // now its showing with black background
    const currentDate = new Date();
    newSubResponse.time = currentDate;

    const setIsOldFunction = (uniqueDate) => {
      if (uniqueDate == newSubResponse.time) { // the purpose of this condition is to check if this is the current massage because sometimes we have multiple timeouts at the same time
        newSubResponse.settings.isOld = true; // now its showing with gray background
        setScrollToMessage(prev => prev + 1)
      }
    }
    setTimeout(setIsOldFunction, 30000, currentDate);
    return subResponse;
  }
  const toggleOpenClose = () => { setIsOpen(prevIsOpen => !prevIsOpen); };
  const parser = new DOMParser();

  const onQuestionClick = (ans, subResponse, answersIndex, assistantId, subResponseIndex) => {
    if (!ans) return;
    const settings = {};
    messagesListRef.current.push({ "assistant_answer_bubble": ans, "answersIndex": answersIndex, "assistantId": assistantId, "subResponseIndex": subResponseIndex , settings })
    subResponse.answer_bubble = [];
    setScrollToMessage(prev => prev + 1)
    SoundPlay(assistantSound);
    setTimeout(() => {
      settings.isOld = true
      reRender({});
    }, 30000);
  }

  return (
    <div className={`assistant ${isOpen ? 'open' : 'close'} ${FlagVars.inGrid ? 'inTasks' : ''}`}>
      <div id="assistant-messages" className="assistant__messages">
        {chatGameId == gameId && messagesListRef.current.map((subResponse, index) => {
          if (subResponse.assistant_bubble) {
            let buttonQuestions = <></>
            if (subResponse.choices_bubble) {
              const values = Object.values(subResponse.choices_bubble);
              buttonQuestions = <div className={`assistant__messages-pc-question first ${subResponse.settings.isOld ? 'old' : ''} `}>
                {values.map((choice, _index) => {
                  return <button onClick={() => onQuestionClick(subResponse?.answer_bubble[_index], subResponse, _index, subResponse.assistantId, subResponse.index)} className={`assistant__messages-pc-question-button ${_index === values.length - 1 ? "assistant__messages-pc-question-button-last" : ""} first ${subResponse.settings.isOld ? 'old' : ''} `} aria-label="choice" key={_index} type="button" dangerouslySetInnerHTML={{ __html: sanitizeHTML(t(`assistant.${subResponse.assistantId}.${parseInt(subResponse.index)}.assistant_options.${_index}`, {id: subResponse.assistantId, index: parseInt(subResponse.index), choice_index: _index})) }} />
                })}
              </div>
            }
            if (subResponse.index == 0) {
              return <>
                <div style={{ display: subResponse?.settings.show !== false ? 'block' : 'none' }} key={index} className={`assistant__messages-pc first ${subResponse.settings.isOld ? 'old' : ''} `} dangerouslySetInnerHTML={{ __html: sanitizeHTML(t(`assistant.${subResponse.assistantId}.${parseInt(subResponse.index)}.assistant_text`, {id: subResponse.assistantId, index: parseInt(subResponse.index)})) }} />
                {/* <div style={{ display: subResponse?.settings.show !== false ? 'block' : 'none' }} key={index} className={`assistant__messages-pc first ${subResponse.settings.isOld ? 'old' : ''} `} dangerouslySetInnerHTML={{ __html: sanitizeHTML(subResponse.assistant_bubble) }} /> */}
                {buttonQuestions}
              </>;
            }
            return <div style={{ display: subResponse?.settings.show !== false ? 'block' : 'none' }} key={index} className={`assistant__messages-pc ${subResponse.settings.isOld ? 'old' : ''} `} dangerouslySetInnerHTML={{ __html: sanitizeHTML(t(`assistant.${subResponse.assistantId}.${parseInt(subResponse.index)}.assistant_text`, {id: subResponse.assistantId, index: parseInt(subResponse.index)}))  }} />;
          } if(subResponse.assistant_answer_bubble){
            return <>
              <div style={{ display: subResponse?.settings.show !== false ? 'block' : 'none' }} key={index} className={`assistant__messages-pc ${subResponse.settings.isOld ? 'old' : ''} `} dangerouslySetInnerHTML={{ __html: sanitizeHTML(t(`assistant.${subResponse.assistantId}.${parseInt(subResponse.subResponseIndex)}.assistant_answer.${subResponse.answersIndex}`, {id: subResponse.assistantId, index: parseInt(subResponse.index), choice_index: subResponse.answersIndex})) }} />
            </>
          }
          return null;
        })}
      </div>
      <button type="button" className="assistant__openBtn" onClick={toggleOpenClose}>?</button>
      <button type="button" className="assistant__closeBtn" onClick={toggleOpenClose} aria-label="Close Assistant">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
});
AssistantChat.displayName = "AssistantChat";
export default AssistantChat;